import { tA11y } from '@utils/a11y/a11yHelpers';
import {
  Ta11yText,
  Link,
  ButtonPrimary,
  Ta11yImage,
  Chip
} from '@core/index';
import { appButtonType, appChipSize, appChipStyle, appIconsPath, appLinkStyle } from '@utils/globalConstant';
import useCmsImage from '@utils/useCmsImage';
import './CardMain.scss';

export function CardMain({
  cardId = '',
  isRecomended = false,
  selected = false,
  chip = '',
  headline = '',
  imageSource = '',
  description = '',
  linkProps = [],
  buttonProps = [],
  description2 = '',
  secondaryButtonProps = []
}) {
  const image = useCmsImage(imageSource);

  return (
    <div className={`card-main-container shadow-xs p-24 animate__animated animate__flipInY h-100 ${isRecomended ? 'bg-primary card-dark text-white' : 'card-light text-primary'}`}>
      {isRecomended && <div className='pb-20'>
        <Chip
          chipStyle={appChipStyle.SECONDARY}
          chipSize={appChipSize.LARGE}
          icon={appIconsPath.STAR}
          label={chip}
          headingTag="div"
        />
      </div>}
      {headline && <Ta11yText textContent={headline} tag="h3" className="ek-h2 pb-20 m-0" />}
      <div className={`text-image-content ${isRecomended ? 'recommanded-image' : ''}`}>
        {imageSource && <div className="image-content">
          <Ta11yImage imageContent={image} className="img-fluid pb-20" />
        </div>}
        {description && <div className="text-content">
          <Ta11yText textContent={description} tag="p" className="ek-copy-16-regular pb-20" />
        </div>}
      </div>
      {linkProps.length
        ? linkProps.map((link, linkIndex) => (
            <Link
              key={`linkKey${linkIndex}`}
              linkStyle={`${isRecomended ? appLinkStyle.WHITE : appLinkStyle.PRIMARY} w-100 mb-20`}
                href='/'
            >
              {tA11y(link.label).content}
            </Link>
          )
        )
        : ""}
      {buttonProps.length
        ? buttonProps.map((button, buttonIndex) => (
            <div className="mb-20" key={`buttonKey${buttonIndex}`}>
              <ButtonPrimary
                buttonType={isRecomended ? appButtonType.SECONDARY : appButtonType.SECONDARY}
                buttonContent={tA11y(button.title)}
                onClick={() => button.onPress(cardId)}
              />
            </div>
          )
        )
        : ""}
      {description2 &&
        <Ta11yText textContent={description2} tag={"p"} className="ek-copy-16-regular pb-20" />
      }
      {secondaryButtonProps.length
        ? secondaryButtonProps.map((button, secondaryButtonIndex) => (
            <Link
              key={`secondaryButtonKey${secondaryButtonIndex}`}
              linkStyle={`${isRecomended ? appLinkStyle.SECONDARY : appLinkStyle.PRIMARY} w-100 card-link m-0`}
              href={tA11y(button.title).url}
              iconRight={appIconsPath.ARROW_RIGHT_SMALL}
              label={tA11y(button.title).content}
            />
          )
        )
        : ""}
    </div>
  );
}

export default CardMain;